import { $btn, $class, $div, $dlg, $img, $inp, $txt, AppManager, assert, clearSchema, fetchText, initWebGpuSims, makeShaderEditors, msg, setAppManager, urlOrigin, urlPathName } from "webgpu-sims";
import { theTagInput } from "./TagInput";
import { bootstrap } from "webgpu-sims";
import { getArticle, getContents, initFirebase, setArticle, theArticles } from "./firebaseTasks";
import { showMarkDown, updatePreview } from "./article";
import { downloadArticlesAsZip, splitContentText } from "./utils-cms";

export let cmpAppManager : CmpAppManager;

class CmpAppManager extends AppManager {
    articleView: HTMLDivElement;

    constructor(){
        super();
        this.articleView = $div("article-view");
        this.views.push(this.articleView);
    }

    getUrlPathName() : string {
        return urlPathName;
    }

    clearArticle(){
        super.clearArticle();
        $inp("title").value = "";
        $txt("markdown-text").value = "";

        setArticle(undefined)
    }

    async renderPage(path: string){
        $div("markdown-article").innerHTML = "";

        if (path === '/gallery'){

            this.clearArticle();

            await getContents();
            this.showView("main-view");
        }
        else if (path.startsWith("/post/")) {
            clearSchema();
            this.showView("edit-view");
            const texts = path.split("/");
            assert(texts.length == 3);
            const id = texts[2];
            // msg(`post:${texts}`);
            const article = await getArticle(id);
            if(article == undefined){
                return;
            }
            setArticle(article);
            const contentText = await fetchText(article.contentFileUrl);
            // msg(`content-File-Url[${article.contentFileUrl}]`)
            const [markdownText, jsonText, schema] = splitContentText(contentText);

            $img("thumbnail-img").src = article.thumbnailUrl;

            $txt("schema-text").value = jsonText;
            makeShaderEditors();

            $inp("title").value = article.title;

            theTagInput.clearTags();
            article.tags.forEach(x => theTagInput.addTag(x));

            $inp("ai-inp").value = article.ai ?? "";

            $txt("markdown-text").value = markdownText;
            updatePreview();

            await showMarkDown($div("markdown-article"), markdownText);

            await bootstrap(schema);
        }
        else if(path == "/wizard" || path == "/run"){
            super.renderPage(path);
        }         
        else{
            msg(`path:[${path}] home:${urlOrigin}/index.html`);
            this.showView("landing-view");
            // window.location.href = `${urlOrigin}/index.html`;
        }
    }
}

function initCmsEventHandler(){
    for(const btn of $class("log-in-btn")){
        btn.addEventListener("click", () => {
            // ログイン画面（FirebaseUI表示状態）へ遷移させる処理
            // 例: navigateTo("SHOW_LOGIN");
            // cmpAppManager.showView("login-view");
            $dlg("sign-in-dlg").showModal();
        });
    }


    $btn("add-details").addEventListener("click", ()=>{
        cmpAppManager.showView("article-view");
    });
}

document.addEventListener('DOMContentLoaded', async () => {
    const bulldog = document.location.href.endsWith("bulldog");
    await initWebGpuSims(false);

    cmpAppManager = new CmpAppManager();

    cmpAppManager.initRender();

    setAppManager(cmpAppManager);

    initCmsEventHandler();
    await initFirebase();

    if(bulldog){
        await getContents(true);
        await downloadArticlesAsZip(theArticles);
    }
});
